// DesktopHeader — top horizontal nav for viewports ≥960px.
//
// Always rendered inside AppShell; CSS hides it below 960px and hides
// the bottom <TabBar> at and above 960px. No JS branching on window
// width so the first paint matches the device class.
//
// Mirrors the mobile TabBar exactly: 4 primary nav slots (Today,
// Taper, Insights, More) + a "Log dose" action button. Community is
// opt-in and reachable through More, so it doesn't get primary nav.
// Admin and Sign out sit on the right for owners.

import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { Home, LineChart, BarChart3, Menu, Plus } from 'lucide-react';
import { Wordmark } from '../brand/Wordmark';
import { Icon } from '../ui/Icon';
import { useAuth } from '../../auth/AuthContext';

const TABS = [
  { to: '/app',          label: 'Today',    icon: Home },
  { to: '/app/taper',    label: 'Taper',    icon: LineChart },
  { to: '/app/insights', label: 'Insights', icon: BarChart3 },
  { to: '/app/more',     label: 'More',     icon: Menu },
];

export function DesktopHeader() {
  const { me, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  function openLog() {
    navigate({ pathname: location.pathname, hash: '#log' });
  }

  return (
    <header className="desktop-header" aria-label="primary">
      <div className="desktop-header-inner container">
        <NavLink
          to="/app"
          className="desktop-header-brand"
          aria-label="Quit Kratom — Today"
        >
          <Wordmark variant="lockup" size="small" />
        </NavLink>
        <nav className="desktop-header-nav" aria-label="sections">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.to === '/app'}
              className={({ isActive }) =>
                `desktop-header-tab${isActive ? ' desktop-header-tab-active' : ''}`
              }
            >
              <Icon icon={t.icon} size={16} />
              <span>{t.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="desktop-header-right">
          <button
            type="button"
            className="desktop-header-cta"
            onClick={openLog}
            aria-label="Log a dose"
            aria-haspopup="dialog"
            aria-expanded={location.hash === '#log'}
          >
            <Icon icon={Plus} size={14} strokeWidth={2.25} />
            <span>Log</span>
          </button>
          {me?.isAdmin ? (
            <NavLink to="/app/admin" className="desktop-header-secondary">
              Admin
            </NavLink>
          ) : null}
          <button
            type="button"
            className="desktop-header-secondary"
            onClick={() => void logout()}
          >
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
